import Login from "../auth/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-tagsinput/react-tagsinput.css'
import 'react-quill/dist/quill.snow.css';
import { BrowserRouter as Router, Navigate, useRoutes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../css/style.css";
import "../css/order.css";
import "../css/media.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useEffect } from "react";
import { db, requestFcmToken, onMessageListener } from "../config/firebase";
import { collection, doc, onSnapshot, setDoc, getDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import { user_subscribe_notification } from "../reduxData/user/userAction";
import { get_user_all_notifications } from "../reduxData/Notifications/notificationActions";
import { Slide, toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "./layout/AdminLayout";
import AppRoutes from "./Approutes";
import { useAdminMessaging } from "../features/notifications/useAdminMessaging";
import { authStorage } from "../api/authStorage";

function App() {

  const dispatch = useDispatch();
  const { user, accessToken, resetToken, userPermissions } = useSelector((state) => state.auth);
  const { isLoading } = useSelector((state) => state.loading);

  useEffect(() => {
    if (!user) return;

    const saveFcmToken = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;
        const token = await requestFcmToken();
        if (!token) return;
        const safeTokenId = token.replace(/[.#$/[\]]/g, "_");
        const userDocRef = doc(db, "notifications", String(user?.id));
        const userDocSnap = await getDoc(userDocRef);
        if (!userDocSnap.exists()) {
          await setDoc(userDocRef, { createdAt: new Date() });
        }
        const tokensColRef = collection(db, "notifications", String(user?.id), "fcm_tokens");
        const tokenRef = doc(tokensColRef, safeTokenId);
        await setDoc(
          tokenRef,
          { token, createdAt: new Date(), updatedAt: new Date() },
          { merge: true }
        );
      } catch (err) {
        console.error("Error in saveFcmToken:", err);
      }
    };

    saveFcmToken();
  }, [user]);

  //store token
  useEffect(() => {
    if (!user) return;

    const saveToken = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const token = await requestFcmToken();
        if (!token) return;

        const safeTokenId = token.replace(/[.#$/[\]]/g, "_");
        const collectionRef = collection(db, "admins");
        const tokenRef = doc(collectionRef, safeTokenId);

        const docSnap = await getDoc(tokenRef);

        if (docSnap.exists()) return;

        await setDoc(tokenRef, { token, passwordUpdate: false, createdAt: serverTimestamp() }, { merge: true });
        // await setDoc(tokenRef, { token: token, passwordUpdateAt: serverTimestamp() }, { merge: true });

      } catch (error) {
        console.error("Error in saveFcmToken:", error);
      }
    };
    saveToken();

  }, [user]);

  //manage token update
  useEffect(() => {
    if (!user) return;
    let snapShotData = null;
    let isProcessingLogout = false;

    const unsubscribe = async () => {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const token = await requestFcmToken();
        if (!token) return;

        const safeTokenId = token.replace(/[.#$/[\]]/g, "_");

        const ref = doc(db, "admins", safeTokenId);

        snapShotData = onSnapshot(ref, async (snapshot) => {
          if (snapshot.exists()) {
            const docdata = snapshot.data();

            // const passwordUpdateAt = docdata?.passwordUpdateAt;
            // const loginTime = localStorage.getItem("loginTime");
            // const serverTime = passwordUpdateAt?.toDate()?.getTime();
            // if (!serverTime) return;
            // const localTime = Number(loginTime);

            if (docdata?.passwordUpdate === true && !isProcessingLogout) {
              isProcessingLogout = true;

              try {

                await updateDoc(ref, { passwordUpdate: false });

                if (snapShotData) snapShotData();
                //  updateDoc(ref, { token: token, passwordUpdate: false }, { merge: true });

                localStorage.clear();
                authStorage.clear();

                window.location.replace("/login");

              } catch (error) {
                console.error("Error updating flag:", error);
                isProcessingLogout = false;
              }
            }

          }
        });

      } catch (error) {
        console.error("Error in Token:", error);
      }
    };

    unsubscribe();

    return () => {
      if (snapShotData) snapShotData();
    };
  }, [user]);

  useAdminMessaging(user);

  return (
    <Router>
      <ToastContainer limit={1} />
      {accessToken ? (
        <AdminLayout isLoading={isLoading}>
          <AppRoutes isLoggedIn={!!accessToken} permissions={userPermissions} />
        </AdminLayout>
      ) : (
        <AppRoutes isLoggedIn={!!accessToken} permissions={userPermissions} />
      )}
    </Router>
  );
}

export default App;
